// extracted by mini-css-extract-plugin
export default {"root":"ProfitabilityLayout_root__ijEdU"};